import { Injectable } from '@angular/core';

import type { Redactor, RedactorConfig } from '../../redactor.types';
import type { RedactorPlugin } from '../interfaces';
import { RedactorExtension } from '../redactor-extension';

declare let $R: Redactor;
const FONT_FAMILY_PLUGIN_TOKEN = 'rt-font-family';

/*
 * This plugin is based on redactor fontfamily plugin
 */
export class FontFamilyPlugin implements RedactorPlugin {
  private app: any;
  private opts: any;
  private lang: any;
  private inline: any;
  private toolbar: any;
  private fonts: Array<{ name: string; value: string }> = [
    {
      name: 'Sans serif',
      value:
        '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Helvetica,Arial,sans-serif',
    },
    { name: 'Arial', value: 'Arial' },
    { name: 'Helvetica', value: 'Helvetica' },
    { name: 'Georgia', value: 'Georgia' },
    { name: 'Times New Roman', value: 'Times New Roman' },
    { name: 'Monospace', value: 'Monospace' },
    {
      name: 'Calibri',
      value: 'Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif',
    },
    { name: 'Verdana', value: 'Verdana,Geneva,sans-serif' },
  ];

  public init(app: any) {
    this.app = app;
    this.opts = app.opts;
    this.lang = app.lang;
    this.inline = app.inline;
    this.toolbar = app.toolbar;

    this.fonts = this.opts.fontfamily ? this.opts.fontfamily : this.fonts;
  }

  public start() {
    const dropdown: any = {};
    for (let i = 0; i < this.fonts.length; i++) {
      const font = this.fonts[i];
      dropdown[i] = {
        title: font.name.replace(/'/g, ''),
        api: `plugin.${FONT_FAMILY_PLUGIN_TOKEN}.set`,
        args: font.value,
      };
    }

    dropdown.remove = {
      title: this.lang.get('remove-font-family'),
      api: `plugin.${FONT_FAMILY_PLUGIN_TOKEN}.remove`,
    };

    const $button = this.toolbar.addButton('fontfamily', { title: this.lang.get('fontfamily') });
    $button.setIcon('<i class="re-icon-fontfamily"></i>');
    $button.setDropdown(dropdown);
  }

  /*
   * Called from dropdown
   */
  public set(value: string) {
    const args = {
      tag: 'span',
      style: { 'font-family': value },
      type: 'toggle',
    };

    this.inline.format(args);
  }

  /*
   * Called from dropdown
   */
  public remove() {
    this.inline.remove({ style: 'font-family' });
  }
}

@Injectable({ providedIn: 'root' })
export class RedactorFontFamilyExtension extends RedactorExtension {
  constructor() {
    super();

    $R.add('plugin', FONT_FAMILY_PLUGIN_TOKEN, new FontFamilyPlugin());
  }

  public canInstall(config: RedactorConfig): boolean {
    return config.plugins!.includes(FONT_FAMILY_PLUGIN_TOKEN);
  }

  public install(config: RedactorConfig): RedactorConfig {
    this.enable();

    return config;
  }
}
